function updateTimer() {
    const timerElement = document.getElementById("M-timer-time");
    if (!timerElement) return;
    let targetTime = localStorage.getItem("targetTime");
    if (!targetTime) {
        targetTime = new Date().getTime() + 15 * 60 * 1000;
        localStorage.setItem("targetTime", targetTime);
    }
    const interval = setInterval(() => {
        const currentTime = new Date().getTime();
        let timeRemaining = targetTime - currentTime;
        if (timeRemaining <= 0) {
        // Reset the target time to a new value (1 minute from now)
        targetTime = new Date().getTime() + 15 * 60 * 1000;
        localStorage.setItem("targetTime", targetTime);
        timeRemaining = targetTime - currentTime;
        }
        const minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
        const seconds = Math.floor((timeRemaining / 1000) % 60);
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');
        timerElement.textContent = `${formattedMinutes}:${formattedSeconds}`;
    }, 1000);
    }
updateTimer();

function initUUPSlider() {
  if (!document.querySelector('.UUPSlider')) return;

  // Destroy any existing instance first to avoid stacking multiple Swipers
  // on the same element after repeated cart updates
  if (window.uupSwiperInstance) {
    window.uupSwiperInstance.destroy(true, true);
    window.uupSwiperInstance = null;
  }

  window.uupSwiperInstance = new Swiper('.UUPSlider', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    pagination: {
      el: '.UUPSlider .swiper-pagination',
      clickable: true
    }
  });
}
document.addEventListener(ThemeEvents.cartUpdate, () => {
  initUUPSlider();
});
document.addEventListener('DOMContentLoaded', initUUPSlider);
document.addEventListener(ThemeEvents.cartUpdate, initUUPSlider);
